var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNuvamaSelected = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.546875,
    width: 41,
    height: 41,
    rx: 12.5,
    fill: "white",
    stroke: "#C59331"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9477 13.2461C29.9477 15.9697 27.7409 18.1769 25.0176 18.1769C22.2944 18.1769 20.0875 15.9697 20.0875 13.2461H16.0547C16.0547 18.1958 20.0687 22.2103 25.0176 22.2103C29.9666 22.2103 33.9806 18.1958 33.9806 13.2461H29.9477Z",
    fill: "#C59331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1266 28.7767C11.1266 26.0531 13.3335 23.8459 16.0567 23.8459C18.7799 23.8459 20.9868 26.0531 20.9868 28.7767H25.0197C25.0197 23.827 21.0057 19.8125 16.0567 19.8125C11.1077 19.8094 7.09375 23.8239 7.09375 28.7767H11.1266Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNuvamaSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nuvamaSelected.5640d880db5e2ec30b8da2512eb2970c.svg";